/* import __COLOCATED_TEMPLATE__ from './post-purchase-empty-state.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import templateOnlyComponent from '@ember/component/template-only';

interface PostPurchaseEmptyStateSignature {
  Args: {
    title: string;
    imageSrc: string;
    imageAlt: string;
    learnMoreHref: string;
    learnMoreLabel?: string;
  };
  Blocks: {
    description: [];
  };
  Element: HTMLDivElement;
}

const PostPurchaseEmptyState = templateOnlyComponent<PostPurchaseEmptyStateSignature>();
export default PostPurchaseEmptyState;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::PostPurchaseEmptyState': typeof PostPurchaseEmptyState;
  }
}
